import { IAutoMapper } from "../../../../../../core/automapper/interfaces";
import { StringHelper } from "../../../../../../utilities/contracts/string-helper";

export const mapOverreadFeedbackDetail = (automapper: IAutoMapper): void => {
  automapper.createMap("default", "OverreadFeedbackDetail")
    .forMember("chaseOverreadFeedbackId", o => o.chaseOverreadFeedbackId)
    .forMember("chaseId", o => o.chaseId)
    .forMember("measureCode", o => o.measureCode)
    .forMember("entityTypeId", o => o.entityTypeId)
    .forMember("entityTypeName", o => o.entityTypeName)
    .forMember("codingUserId", o => o.codingUserId)
    .forMember("codingUserName", o => o.codingUserName)
    .forMember("qaUserId", o => o.qaUserId)
    .forMember("qaUserName", o => o.qaUserName)
    .forMember("codingData", o => o.codingData)
    .forMember("qaData", o => o.qaData)
    .forMember("chaseOverreadFeedbackStatus", o => o.chaseOverreadFeedbackStatus)
    .forMember("codingReceiptStatus", o => o.codingReceiptStatus)
    .forMember("qaReceiptStatus", o => o.qaReceiptStatus)
    .forMember("codingComment", o => o.codingComment)
    .forMember("qaComment", o => o.qaComment)
    .forMember("managerComment", o => o.managerComment);
};

export class OverreadFeedbackDetail {
  chaseOverreadFeedbackId: number;
  chaseId: number;
  measureCode: string;
  entityTypeId: number;
  entityTypeName: string;
  codingUserId: number;
  codingUserName: string;
  qaUserId: number;
  qaUserName: string;
  codingData: string;
  qaData: string;
  chaseOverreadFeedbackStatus: string;
  codingReceiptStatus: string;
  qaReceiptStatus: string;
  codingComment: string;
  qaComment: string;
  managerComment: string;

  constructor(options: Partial<OverreadFeedbackDetail>) {
    this.chaseOverreadFeedbackId = options.chaseOverreadFeedbackId;
    this.chaseId = options.chaseId;
    this.measureCode = StringHelper.clean(options.measureCode);
    this.entityTypeId = options.entityTypeId;
    this.entityTypeName = StringHelper.clean(options.entityTypeName);
    this.codingUserId = options.codingUserId;
    this.codingUserName = StringHelper.clean(options.codingUserName);
    this.qaUserId = options.qaUserId;
    this.qaUserName = StringHelper.clean(options.qaUserName);
    this.codingData = StringHelper.clean(options.codingData);
    this.qaData = StringHelper.clean(options.qaData);
    this.chaseOverreadFeedbackStatus = StringHelper.clean(options.chaseOverreadFeedbackStatus);
    this.codingReceiptStatus = StringHelper.clean(options.codingReceiptStatus);
    this.qaReceiptStatus = StringHelper.clean(options.qaReceiptStatus);
    this.codingComment = StringHelper.clean(options.codingComment);
    this.qaComment = StringHelper.clean(options.qaComment);
    this.managerComment = StringHelper.clean(options.managerComment);
  }
}
